<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-licenca') }}
                </h1>
            </div>

            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar :onSearch="debouncedOnSearch" />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table v-else :data="licencas" class="data-table" @sort="sortTable" backend-sorting>
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div v-if="f.key == 'descricao'">
                        <a @click="select(props.row)">
                            {{ props.row[f.key] }}
                        </a>
                    </div>
                    <div v-else-if="f.key == 'bloqueiavenda'">
                        {{ props.row[f.key] == 1 ? $t('sim') : $t('nao') }}
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AssClienteLicencaService from '@/services/vendas/cliente/abas/AssClienteLicencaService';

export default {
    props: {
        idCliente: 0,
    },
    data() {
        return {
            service: new AssClienteLicencaService(this.$http, this.$router),
            licencas: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'idlicenca', width: null, sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'bloqueiavenda', width: null, sortable: false, sortFn: null },
            ],
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],

            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idCliente,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.licencas = value;
                    this.isEmpty = this.licencas.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findNaoAssociados(column, order, page, limit, id, ...params) {
            if (this.isVenda) {
                return this.service.findNaoAssociadosVendas(
                    column,
                    order,
                    page,
                    limit,
                    id,
                    ...params
                );
            } else {
                return this.service.findNaoAssociadosAgro(
                    column,
                    order,
                    page,
                    limit,
                    id,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idcliente: this.idCliente,
                    idlicenca: m.idlicenca,
                    descricao: m.descricao,
                    bloqueiavenda: m.bloqueiavenda,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        select(selected) {
            this.$emit('selected', selected);
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
